import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import useLenis from "../../lib/useLenis";
import Navigation from "./Navigation";
import Hero from "./Hero";
import Work from "./Work";
import Contact from "./Contact";

export const Portfolio = () => {
    useLenis();
    const location = useLocation();

    useEffect(() => {
        if (location.hash) {
            const id = location.hash.replace("#", "");
            // wait a tick so the anchor exists and Lenis is mounted
            const t = setTimeout(() => {
                const el = document.getElementById(id);
                if (el) {
                    el.scrollIntoView({ behavior: "smooth", block: "start" });
                }
            }, 220);
            return () => clearTimeout(t);
        }
        window.scrollTo({ top: 0, left: 0, behavior: "instant" });
    }, [location.hash, location.pathname]);

    return (
        <main
            className="grain relative bg-cream text-text-primary overflow-x-hidden"
            data-testid="portfolio-root"
        >
            <Navigation />
            <Hero />
            <Work />
            <Contact />
        </main>
    );
};

export default Portfolio;
